import React, { useState, useEffect } from 'react';
import { Row, Col } from 'components/ui/grid';
import { Loader } from 'components/ui';
import { useI18n } from 'hooks/use_i18n';
import InitializingRequestImage from 'images/init_request.svg';
import EmptyState from 'components/ui/empty_state';

const InitializingRequest = ({ progress, isLoading, minTime = 400 }) => {
  const [showLoader, setShowLoader] = useState(false);
  const { t } = useI18n();

  useEffect(() => {
    let showTimer;
    let hideTimer;

    if (isLoading) {
      showTimer = setTimeout(() => setShowLoader(true), minTime);
    } else if (showLoader) {
      hideTimer = setTimeout(() => setShowLoader(false), minTime);
    }

    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, [isLoading, showLoader, minTime]);

  if (!showLoader) return null;

  return (
    <Row className="p-card">
      <Col
        sm={12}
        md={{
          size: 6,
          offset: 3,
        }}
      >
        <EmptyState
          className="mt-4"
          title={t('components.request.initializing_request.initializing_request_title')}
          subTitle={progress ? t(`components.request.initializing_request.progress_step.${progress}`) : t('components.request.initializing_request.progress_step.default')}
          image={InitializingRequestImage}
          action={Loader}
        />
      </Col>
    </Row>
  );
};

export default InitializingRequest;
